interface FormattedOption {
	option: string
	value: string | number
}

export const formatOptions = <T extends { id: string | number; name: string }>(
	data: T[] | undefined,
	defaultLabel: string
): FormattedOption[] => {
	const options =
		data?.map((item) => ({
			option: item.name,
			value: item.id,
		})) || []

	return [{ option: defaultLabel, value: '' }, ...options]
}
